module.exports = __webpack_public_path__ + "img/45b74c4e5de5ec2fb93d4facbe99a015.png";